var noConflict = {exports: {}};

export { noConflict as n };
